import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Box, 
  Divider,
  Alert
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import QueueItem from './QueueItem';

const ProcessingQueue = ({ 
  queue = [], 
  progress = {}, 
  isPaused, 
  onPauseResume, 
  calculateETA,
  onPreview
}) => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="div">
            Cola de Procesamiento
          </Typography>
          
          <Button 
            variant="outlined"
            color={isPaused ? "success" : "warning"}
            startIcon={isPaused ? <PlayArrowIcon /> : <PauseIcon />}
            onClick={onPauseResume}
            size="small"
          >
            {isPaused ? 'Reanudar Cola' : 'Pausar Cola'}
          </Button>
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        {queue.length > 0 ? (
          queue.map((item, index) => {
            const itemProgress = progress[item.filename] || progress[item.originalFilename] || {};
            
            return (
              <QueueItem 
                key={index}
                item={item}
                progressInfo={itemProgress}
                calculateETA={calculateETA}
                onPreview={onPreview}
              />
            );
          })
        ) : (
          <Alert severity="info">No hay archivos en la cola de procesamiento.</Alert>
        )}
      </CardContent>
    </Card>
  );
};

export default ProcessingQueue; 